import { connectedStore } from '../../store';
import selectors from '../selectors';

const getParentFolderId = (pageId) => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getParentFolderId(state, pageId);
};

export default getParentFolderId;
